import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import RegisterStat from './RegisterStat';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    <RegisterStat endpoint='https://stats.soliman.nl/register' site="soliman.nl" app="secret" module="home" />
    <App />
  </div>
);